<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row" v-if="permissions">
                <div class="col-lg-12">
                    <div class="type_package" >
                        
                    </div>
                    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <form  @submit.prevent="importmenu">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Enregistrement par fichier</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                       <a href="/assets/client_import.xlsx" class="btn m-10 btn-primary add-list" ><i class="las la-plus mr-3"></i>Exporter le model</a>
                                        <br><br>
                                        <input class="btn col-lg-9 mr-3 btn-primary add-list" type="file" name="" id="file" ref="photos" >
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn m-10 btn-primary add-list pull-right" data-dismiss="modal">Retour</button>
                                        <button type="submit" class="btn btn-primary">Enregistrer</button>
                                    </div>
                                </form>
                            </div>
                            <div class="vld-parent">
                                <loading :active.sync="isLoad" 
                                :can-cancel="true" 
                                :is-full-page="fullPage"></loading>
                            </div>
                        </div>
                        </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Clients</h4>
                        </div>
                        <a href="/create-user"  class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Ajouter un client</a>
                        <a  class="btn btn-primary add-list" data-toggle="modal" data-target="#exampleModal" ><i class="las la-plus mr-3"></i>Ajouter client par fichier</a>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="table-responsive rounded mb-3">
                        <table id="example" class="data-table table mb-0 tbl-server-info">
                            <thead class="bg-white text-uppercase">
                                <tr class="ligth ligth-data">
                                    <th>Email</th>
                                    <th>Nom</th>
                                    <th>Prenoms</th>
                                    <th>Contact</th>
                                    <th>Entreprise</th>
                                    <th>Fonction</th>
                                    <th>Date de création</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody class="ligth-body">
                                <tr v-for="(user,index) in users" :key="index">
                                    <td v-if="user.email">{{user.email}}</td>
                                    <td v-else>pas de mail</td>
                                    <td>{{user.nom}}</td>
                                    <td>{{user.prenoms}}</td>  
                                    <td>{{user.phone}}</td> 
                                    <td v-if="user.entreprise"> {{ user.entreprise.name }} </td>
                                    <td v-else></td>
                                    <td> {{ user.fonction }} </td>
                                    <td> {{ moment(user.created_at).format('DD  MMMM  YYYY H:mm')}} </td>
                                    <td >
                                        <div class="d-flex align-items-center list-action">

                                        <button v-if="user"  class="badge badge-info bg-warning mr-2 btn" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="destroy(user.id)"><i class="fa fa-trash mr-0"></i></button>
                                        <button v-if="user && user.active == 0" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(user.id,1)"><i class="fa fa-lock mr-0"></i></button>
                                        <button v-if="user && user.active == 1" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(user.id,0)"><i class="fa fa-unlock mr-0"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="vld-parent">
                        <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :is-full-page="fullPage"></loading>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {URL_API} from '@/config'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Swal from 'sweetalert2'
import $ from "jquery"
import moment from 'moment'
moment.locale('fr')
export default {
    components: {
            Loading
    },
    data() {
        return {
            permissions: [],
            users:{},
            isLoading: false,
            isLoad: false,
            fullPage: true,
            see_form: false,
            URL_API: URL_API,
            moment:moment
        };
    },
    mounted(){
        this.getusers()
    },
    methods:{
       
        see(){
            this.see_form = true
        },
        back(){
            this.see_form = false
        },
        importmenu(){
                    let app = this
                    this.isLoad = true
                    var menuData = new FormData();
                    app.photos = app.$refs.photos.files
                    let file = app.photos[0];
                    console.log(file)
                    if (file != null) {
                        menuData.append('file', file);
                        axios.post(URL_API+'users-excel', menuData)
                        .then(function (reponse){
                            console.log(reponse)
                            let response = JSON.parse(reponse.data.status)
                            app.isLoad = false
                            if(response.success){
                                app.$router.push('/index-client')
                                Swal.fire('Succès', 'Client(s) ajouté(s)', 'success')
                            }else{
                                Swal.fire('Attention', response.error.message, 'error')
                            }
                        })
                        .catch(function (error){
                            app.isLoad = false
                            Swal.fire('Erreur', 'Le fichier n\'est pas correctement renseigné ou client deja existant', 'error')
                            console.log(error);
                        })
                    }
        },
        async resetU () {
            const { value: fruit } = await Swal.fire({
                title: 'Select field validation',
                input: 'select',
                inputOptions: {
                    'Student': 'Student',
                    'Staff': 'Staff',
                },
                inputPlaceholder: 'Select a profile',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value) {
                            resolve()
                        } else {
                            resolve('Choose a profile')
                        }
                    })
                }
            })

            if (fruit) {
                axios.post(URL_API+'resetUser', {role: fruit})
                .then(function (rep) {
                    console.log(rep);
                    if (rep.data.status == true) {
                        Swal.fire('Successful', 'Balances reset', 'success')
                    } else {
                        Swal.fire('Warning', rep.data.message, 'warning')
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    Swal.fire('Error', 'An unknown error occured', 'error')
                })
            }
        },
        getusers() {
            this.isLoading =  true
            axios.get(URL_API+'users-client')
            .then(response => {
                console.log(response)
                if (response.data.status == true) {
                    $(document).ready( function () {
                            $('#example').DataTable(
                                {
                                    "lengthMenu": [ 5,10, 25, 50, 75, 100 ],
                                    "pageLength": 10,
                                    'order':[],
                                    stateSave: true,
                                    "bDestroy": true
                                }
                            );
                        } );
                this.users = response.data.data
                this.isLoading =  false
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                Swal.fire(
                        'Error!',
                        'An error occured while fetching datas',
                        'error'
                )
                this.isLoading =  false
            })
        },
        destroy(id) {
            Swal.fire({
                title: 'Vous vous supprimer ce compte ?',
                text: "Cette action est irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete(URL_API+'user/'+id)
                    .then(response => {
                        console.log(response.data)
                        this.users = response.data
                        this.isLoading =  false
                        Swal.fire(
                            'Supprimé!',
                            'Cet utilisateur a été supprimé avec succès',
                            'success'
                        )
                        location.reload()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
        active(userID,id) {
            let app = this
            Swal.fire({
                title: 'do you want to enable/disable this account?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.post(URL_API+'active-disable',{
                        user_id:userID,
                        active:id
                    })
                    .then(response => {
                        console.log(response.data)
                        this.isLoading =  false
                        if (id == 0) {
                            Swal.fire(
                                'Success!',
                                'account Disabled',
                                'success'
                            )
                        } else {
                            Swal.fire(
                                'Success!',
                                'activated account',
                                'success'
                            )
                        }
                        
                        app.getusers()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
    }
}
</script>